export const MODALS = {
    CONFIRMATION: 'CONFIRMATION',
}

export const MODAL_ACTIONS = {
    REFUND_PAYMENT: 'REFUND_PAYMENT',
}
